"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = ({ components, palette, shadows, spacing, typography }) => ({
    headlineText: {
        fontWeight: typography.fontWeightLight,
        lineHeight: spacing(4),
        letterSpacing: 0.2,
    },
    headlineIcon: {
        maxHeight: spacing(4),
        maxWidth: spacing(4),
        width: components.navigation.iconSize,
        height: components.navigation.iconSize,
        marginBottom: 4,
        marginRight: spacing(2),
        color: components.report.headerTypographyColor,
    },
    personalDetails: {
        border: `1px solid ${palette.divider}`,
        padding: spacing(2),
        backgroundColor: palette.background.default,
        boxShadow: shadows[1],
    },
    contentRow: {
        justifyContent: 'space-between',
        display: 'flex',
        alignItems: 'center',
        marginRight: spacing(2),
    },
});
exports.default = styles;
